



























import { Prop, Component, Vue, Mixins } from 'vue-property-decorator';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import BaseNumbersTile, { IBaseNumbersTileConfiguration } from './BaseNumbersTile.vue';
import { Getter } from 'vuex-class';
import { IN2KWaterDepthEvent, N2KHeadingEventReference, IN2KHeadingEvent } from '../../common/apis/DeviceApi';
import UserMixin from '@/mixins/UserMixin';

@Component({
    components: {
        BaseNumbersTile,
    },
})
export default class HeadingTile extends Mixins(TileComponentMixin, UserMixin) {
    @Prop({required: false})
    public configuration?: IBaseNumbersTileConfiguration;

    public get available() {
        for (const headingKey in this.headings) {
            if (this.headings[(headingKey as any) as N2KHeadingEventReference]) {
                return true;
            }
        }
        return false;
    }

    public get heading(): IN2KHeadingEvent | null {
        if (this.headings && this.headings.True) {
            return this.headings.True;
        }
        if (this.headings && this.headings.Magnetic) {
            return this.headings.Magnetic;
        }
        if (this.isDemo) {
            return this.demoData;
        }
        return null;
    }

    public get headings(): {[key in N2KHeadingEventReference]?: IN2KHeadingEvent} {
        return this.getHeading(this.deviceNumber) || {};
    }

    public get headingFormatted(): string {
        if (this.heading && typeof this.heading.heading === 'number') {
            return this.heading.heading.toFixed(0) + '°';
        }
        return '--';
    }

    public get referenceFormatted(): string {
        if (this.heading && this.heading.reference) {
            if (this.heading.reference === N2KHeadingEventReference.True) {
                return this.$t('tiles.heading.true-heading').toString();
            } else if (this.heading.reference === N2KHeadingEventReference.Magnetic) {
                return this.$t('tiles.heading.magnetic-heading').toString();
            }
        }
        return '--';
    }

    @Getter('n2k/heading')
    private getHeading: (deviceNumber: string) => {[key in N2KHeadingEventReference]?: IN2KHeadingEvent} | null;
    private demoData: IN2KHeadingEvent | null = null;
    private demoDataInterval: number;

    public ageInSeconds(event: IN2KHeadingEvent): number | null {
        if (event && event.timestamp) {
            const timestamp = typeof event.timestamp === 'object'
                ? event.timestamp
                : new Date(event.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return null;
    }

    public mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 1000);
        }
    }
    public async beforeDestroy() {
        clearInterval(this.demoDataInterval);
    }


    private generateDemoData() {
        let heading = (this.demoData ? this.demoData.heading : undefined) || Math.random() * 360;

        heading += Math.random() * 5 - 2.5;
        if (heading > 360) {
            heading = 0;
        }
        if (heading < 0) {
            heading = 360;
        }

        this.demoData = {
            reference: N2KHeadingEventReference.True,
            heading,
            deviation: 0,
            variation: 0,
            sensorNumber: 0,
            deviceNumber: this.deviceNumber,
            timestamp: new Date(),
        };
    }
}
